export const validateExistingRefereeNames = (
  firstName,
  lastName,
  email,
  fellows,
  nonAasReferees,
) => {
  if (!firstName || !lastName) return null;

  const trimmedFirstName = firstName.trim();
  const trimmedLastName = lastName.trim();
  const trimmedEmail = email?.trim();

  if (!trimmedFirstName || !trimmedLastName) return null;

  const matchingFellows =
    fellows?.filter(
      (fellow) =>
        fellow.attributes.name?.toLowerCase().trim() ===
          trimmedFirstName.toLowerCase() &&
        fellow.attributes.lastName?.toLowerCase().trim() ===
          trimmedLastName.toLowerCase(),
    ) || [];

  const matchingNonAasReferees =
    nonAasReferees?.filter((referee) => {
      const nameMatch =
        referee.attributes.name?.toLowerCase().trim() ===
          trimmedFirstName.toLowerCase() &&
        referee.attributes.lastName?.toLowerCase().trim() ===
          trimmedLastName.toLowerCase();

      const emailMatch =
        trimmedEmail &&
        referee.attributes.email &&
        referee.attributes.email.toLowerCase().trim() ===
          trimmedEmail.toLowerCase();

      return nameMatch || emailMatch;
    }) || [];

  if (matchingFellows.length > 0) {
    let message;

    if (matchingFellows.length === 1) {
      const matchingFellow = matchingFellows[0];
      const fellowName = `${matchingFellow.attributes.name} ${matchingFellow.attributes.lastName}`;
      const fellowEmail = matchingFellow.attributes.email;
      const isDeceased = matchingFellow.attributes.active === false;
      const isDoNotContact = matchingFellow.attributes.doNotContact === true;

      if (isDeceased) {
        message = `We found a fellow with a similar name: ${fellowName} (${fellowEmail}). Please note this fellow is deceased and cannot be selected.`;
      } else if (isDoNotContact) {
        message = `We found a fellow with a similar name: ${fellowName} (${fellowEmail}). Please note this fellow has requested not to be contacted.`;
      } else {
        message = `We found a fellow with a similar name: ${fellowName} (${fellowEmail}). If this is the same person, please select them from the dropdown above.`;
      }
    } else {
      const deceasedCount = matchingFellows.filter(
        (f) => f.attributes.active === false,
      ).length;
      const doNotContactCount = matchingFellows.filter(
        (f) =>
          f.attributes.doNotContact === true && f.attributes.active !== false,
      ).length;
      const availableCount =
        matchingFellows.length - deceasedCount - doNotContactCount;

      if (availableCount > 0) {
        message = `We found ${matchingFellows.length} fellows with this name. If you're referring to an existing fellow, please select them from the dropdown above.`;
      } else {
        message = `We found ${matchingFellows.length} fellows with this name, but none are available (${deceasedCount} deceased, ${doNotContactCount} have requested not to be contacted).`;
      }
    }

    return { type: 'fellow', message, matches: matchingFellows };
  }

  if (matchingNonAasReferees.length > 0) {
    let message;

    if (matchingNonAasReferees.length === 1) {
      const matchingReferee = matchingNonAasReferees[0];
      const refereeName = `${matchingReferee?.attributes?.name || ''} ${matchingReferee?.attributes?.lastName || ''}`;
      const refereeEmail = matchingReferee.attributes.email;
      const isInactive = matchingReferee.attributes.isActive === false;

      if (isInactive) {
        message = `We found an existing non-AAS referee with a similar name: ${refereeName} (${refereeEmail}). Please note this referee is inactive and cannot be selected. Please contact fellowship@science.org.au for assistance`;
      } else {
        message = `We found an existing non-AAS referee with a similar name: ${refereeName} (${refereeEmail}). If this is the same person, please select them from the dropdown above.`;
      }
    } else {
      const inactiveCount = matchingNonAasReferees.filter(
        (r) => r.attributes.isActive === false,
      ).length;
      const availableCount = matchingNonAasReferees.length - inactiveCount;

      if (availableCount > 0) {
        message = `We found ${matchingNonAasReferees.length} existing non-AAS referees with this name. If you're referring to an existing referee, please select them from the dropdown above.`;
      } else {
        message = `We found ${matchingNonAasReferees.length} existing non-AAS referees with this name, but they are all inactive and cannot be selected.`;
      }
    }

    return {
      type: 'nonAasReferee',
      message,
      matches: matchingNonAasReferees,
    };
  }

  return null;
};
